import DigitPasswordCircle from '../assets/fonts/DigitPasswordCircle.ttf';
import DigitPasswordSquare from '../assets/fonts/DigitPasswordSquare.ttf';
import OutfitLight from '../assets/fonts/Outfit-Light.ttf';
import OutfitRegular from '../assets/fonts/Outfit-Regular.ttf';
import OutfitSemiBold from '../assets/fonts/Outfit-Semibold.ttf';
export const FONTS_RELOADED_NOVA_GLOBAL_STYLES = `
  @font-face {
    font-family: 'Outfit Font';
    font-weight: 700;
    src: url(${OutfitSemiBold}) format('truetype');
  }

  @font-face {
    font-family: 'Outfit Font';
    font-weight: 400;
    src: url(${OutfitRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Outfit Font';
    font-weight: 300;
    src: url(${OutfitLight}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordCircle';
    font-weight: 400;
    src: url(${DigitPasswordCircle}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordSquare';
    font-weight: 400;
    src: url(${DigitPasswordSquare}) format('truetype');
  }
`;
//# sourceMappingURL=fonts.js.map